import { apiFetch } from './client';

export const getStigLibrary     = ()                    => apiFetch('/stig/library');
export const getAssetChecks     = (assetId, params={})  => apiFetch(`/stig/asset/${assetId}/checks?${new URLSearchParams(params)}`);
export const getAssignedStigs   = (assetId)             => apiFetch(`/stig/asset/${assetId}/assigned`);
export const applyStig          = (assetId, filename)   => apiFetch(`/stig/asset/${assetId}/apply`, { method: 'POST', body: JSON.stringify({ filename }) });
export const updateCheck        = (checkId, data)       => apiFetch(`/stig/check/${checkId}`, { method: 'PUT', body: JSON.stringify(data) });
export const bulkApplyStig      = (filename, asset_ids) =>
  apiFetch('/stig/bulk-apply', { method: 'POST', body: JSON.stringify({ filename, asset_ids }) });

export const uploadCkl          = (assetId, file)       => {
  const form = new FormData();
  form.append('file', file);
  return fetch(`/api/stig/asset/${assetId}/upload-ckl`, { method: 'POST', body: form }).then(r => r.json());
};
